module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Live stream",
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$emit('update:visible', $event)
      }
    }
  }, [_c('el-form', {
    ref: "streamRequest",
    attrs: {
      "model": _vm.streamRequest,
      "rules": _vm.rules
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 24,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Channels",
      "label-width": "120px",
      "prop": "channels"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Please select channels"
    },
    model: {
      value: (_vm.streamRequest.channels),
      callback: function($$v) {
        _vm.$set(_vm.streamRequest, "channels", $$v)
      },
      expression: "streamRequest.channels"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.channelIndex
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.streamRequest.error) ? _c('el-form-item', [_vm._v("Error: " + _vm._s(_vm.streamRequest.error))]) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.startStream
    }
  }, [_vm._v("Confirm")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ab1e70a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/devices/LiveStreamDialog.vue
// module id = 1165
// module chunks = 2